import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

// Renders official Apple "Download on the App Store" and Google "Get it on
// Google Play" badges as anchors to the prod store listings. Inputs are the
// full install URLs (built server-side by buildInstallUrlsForClaim) so the
// Play Store anchor carries the install-referrer with the purchase claim
// token for Phase 1's auto-sign-in handoff.
//
// Inputs are optional: omit one to hide that badge, omit both and the
// component renders nothing (host gets the badges--empty class which CSS
// uses to collapse layout).
@Component({
  selector: 'cs-store-badges',
  templateUrl: 'cs-store-badges.html',
  styleUrls: ['cs-store-badges.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { 'class': 'store-badges' }
})
export class CsStoreBadgesComponent {
  @Input() androidInstallUrl?: string;
  @Input() iosInstallUrl?: string;

  // Vendor-prescribed alt text per Apple Marketing Guidelines + Google Play
  // badge guidelines — must NOT be translated. Exposed as fields so the
  // template binds via [alt]="..." (which the untranslated-strings linter
  // skips, unlike plain alt="..." attributes).
  readonly googleBadgeAlt = 'Get it on Google Play';
  readonly appleBadgeAlt = 'Download on the App Store';

  @HostBinding('class.store-badges--empty')
  get isEmpty(): boolean {
    return !this.androidInstallUrl && !this.iosInstallUrl;
  }
}
